jQuery(document).ready(function ($) {
    var icons = {
        arrow: 'arrow-left.svg',
    };
    var loadedIcons = {};
    var themeBasePath = jQuery('meta[name=theme-base-path]').attr('content') + '/';
    $('.slick-slider').find('.icon.icon-left-arrows,.icon.icon-right-arrow1').each(function () {
        var curIcon = 'arrow';
        if (!icons[curIcon])
            return true;
        $(this).attr('data-icon', curIcon);
        if (loadedIcons[curIcon] != 'loading' || !loadedIcons[curIcon]) {
            loadedIcons[curIcon] = 'loading';
            console.log(themeBasePath + 'dist/img/' + icons[curIcon]);
            $.ajax(themeBasePath + 'dist/img/' + icons[curIcon], {
                dataType: 'text',
                success: function (data) {
                    $('[data-icon=' + curIcon + ']').html(data).addClass('fa-added');
                    loadedIcons[curIcon] = data;
                }
            });
        }
        else if (loadedIcons[curIcon] != 'loading')
            $(this).html(loadedIcons[curIcon]).addClass('fa-added');

    });
    $(document).on('click', '[data-action="replace-large"]', function (e) {
        e.preventDefault();
        var $largeImage = $(this).closest('.product-gallery-item').find('.large-image').html();
        var $target = $($(this).data('target'));
        $target.animate({
            opacity: 0
        }, 300, function () {
            $target.html($largeImage);
            $target.css({ opacity: 0 }).find('.product-large').removeClass('d-none');
            $target.animate({ opacity: 1 }, 300);
        });
    });

    $(document).on('click', '.slick-slide a', function (e) {
        var href = $(this).attr('href');

        if (href.indexOf('/products/') > 0) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            var $popover = animateInPopover();
            $.ajax(href, {
                success: function (data) {
                    var html = $(data).find('#product-contain .full-screen-popover').html();
                    animateContentOnPopover($popover, html);
                    var curTitle = document.title;
                    var curPath = window.location.href;
                    document.title = $(data).filter('title').text();
                    var pageTitle = document.title;
                    window.history.pushState({ "pageTitle": pageTitle, 'html': html }, pageTitle, href);
                    $('.full-screen-popover .burger').on('click', function (e) {
                        e.preventDefault();
                        $(this).off('click');
                        window.history.pushState({ "pageTitle": curTitle, 'closeDialog': true }, curTitle, curPath);
                        $(this).closest('.full-screen-popover').animate({
                            top: '-100vh'
                        }, 1000, 'easeOutSine', function () {
                            $('body').removeClass('menu-is-open');
                            $(this).remove();
                        });
                    });
                }
            });
        }
    });

    function animateInPopover() {
        var $popover = $('<div class="full-screen-popover" />');
        $popover.css({
            top: '-100vh'
        });
        $('body').addClass('menu-is-open').append($popover);
        var top = 0;
        if ($('.admin-bar').length && $('#wpadminbar').css('position') == 'fixed')
            top += 32;
        $popover.animate({
            top: top
        }, {
            duration: 1000,
            // easing: 'easeOutBounce'
            easing: 'easeOutSine'
        });
        return $popover;
    }

    function animateContentOnPopover($popover, html) {
        $popover.append(html);
        $popover.find('>*').css('opacity', 0);
        $popover.find('>*').animate({
            opacity: 1
        }, {
            c,
            duration: 500
        });
    }

    window.onpopstate = function (e) {
        if (e.state && e.state.html) {
            var $popover = animateInPopover();
            animateContentOnPopover($popover, e.state.html);
        }
        else if (e.state.closeDialog && $('.full-screen-popover').length) {
            $('.full-screen-popover').animate({
                top: '-100vh'
            }, 1000, 'easeOutSine', function () {
                $('body').removeClass('menu-is-open');
                $(this).remove();
            });
        }
        else {
            window.location = e.target.location;
        }
    };
});